import { Flex as FlexBase } from "@rebass/grid";
import styled, { spacing } from "@rentiohq/web-theme";

export const Card = styled.div`
  border-radius: 4px;
  border: 0.719px solid ${({ theme }) => theme.colors.neutral30};
  background: ${({ theme }) => theme.colors.neutral0};
  box-shadow: 0 0.719px 1.438px 0 rgba(0, 0, 0, 0.05);
  display: flex;
  overflow: hidden;
`;

export const Content = styled.div`
  width: 100%;
  padding: ${spacing("loose")};
`;

export const SectionTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.neutral100};
`;

export const SectionSubtext = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.neutral80};
`;

export const RoundedBorder = styled.div`
  width: 8px;
  margin: 1px 0;
  border-radius: 0 8px 8px 0;
  background: ${({ theme }) => theme.getColor("yellow", 1000)};
`;

export const Flex = styled(FlexBase)`
  gap: 16px;
`;
